import { Component, ElementRef, OnDestroy, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { RatingService } from '../../../../services/rating.service';
import { SettingsService } from '../../../../services/settings.service';
import { teamMoodsViews } from '../team-mood.component';
import * as uuid from 'uuid';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-team-mood-sprint-avg-chart',
  templateUrl: './team-mood-sprint-avg-chart.component.html',
  styleUrls: ['./team-mood-sprint-avg-chart.component.scss']
  })

export class TeamMoodSprintAvgChartComponent implements OnInit, OnDestroy {
  @ViewChild('divcontainer') private element: ElementRef;
  @Output() navigate = new EventEmitter<teamMoodsViews>();
  public projectKey: string;
  public dataSets: any[] = [];
  public dataset: any[] = [];
  public questions: string[] = [];
  public colors: string[] = [];
  public sprints: any[] = [];
  public chart: Chart;

  private event: Subscription[] = [];
  public numberOfQuestions = 0;
  public chartId = 'team-mood-question-line-chart' + uuid.v4();

  constructor(
    private settingsService: SettingsService,
    private ratingService: RatingService) {

  }

  ngOnInit(): void {
    this.event.push(this.settingsService.getUpdateObservable().subscribe(() => {
      this.projectKey = this.settingsService.getProjectName();
      this.loadData();
    }));
    this.projectKey = this.settingsService.getProjectName();
    this.loadData();
    document.getElementById('navigationSprintAvgLeft').addEventListener('click', () => {
      this.navigateToVoting();
    });

    document.getElementById('navigationSprintAvgRight').addEventListener('click', () => {
      this.navigateToFeedback();
    });
  }

  loadData() {
    this.questions = [];
    this.dataSets = [];
    this.dataset = [];

    this.ratingService.getAvgPerSprintForProject(this.projectKey).subscribe(res => {
      const keys = Object.keys(res['dataset']);
      const len = keys.length;
      this.numberOfQuestions = len;

      for (let i = 0; i < len; i++) {
        this.dataSets.push(res['dataset'][i].data);
        this.questions.push(res['dataset'][i].question.name);
        this.colors.push(res['dataset'][i].question.color);
      }
      this.sprints = res['label'];
      this.setupDataset();
    });
  }

  setupDataset() {
    this.dataset = [];

    for (let i = 0; i < this.numberOfQuestions; i++) {
      this.dataset.push({
        label: this.questions[i],
        backgroundColor: this.colors[i],
        borderColor: this.colors[i],
        hitRadius: 10,
        spanGaps: true,
        fill: false,
        data: this.dataSets[i]
      });
    }

    this.setupChart();
  }


  setupChart() {
    if (this.chart) {
      this.chart.destroy();
    }
    if (this.sprints) {
      const canvas: any = document.getElementById(this.chartId);
      const ctx = canvas.getContext('2d');

      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.sprints,
          datasets: this.dataset

        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              min: 1,
              max: 5,
              ticks: { stepSize: 1 }
            }
          }
        }
      });
    }
  }

  ngOnDestroy(): void {
    for (const ev of this.event) {
      ev.unsubscribe();
    }
  }

  navigateToFeedback() {
    this.navigate.emit(teamMoodsViews.showFeedback);
  }

  navigateToVoting() {
    this.navigate.emit(teamMoodsViews.showTimeRange);
  }
}
